import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext } from "react";
import SVG from "react-inlinesvg";
const scheduleData = [
  {
    "state_en": "West Bengal",
    "state_hi": "पश्चिम बंगाल",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 152,
        "notification": "30-03-2026",
        "nomination_last_date": "06-04-2026",
        "scrutiny_last_date": "07-04-2026",
        "withdrawal_last_date": "09-04-2026",
        "polling": "23-04-2026",
        "counting": "04-05-2026"
      },
      {
        "phase": "दूसरा चरण",
        "seats": 142,
        "notification": "02-04-2026",
        "nomination_last_date": "09-04-2026",
        "scrutiny_last_date": "10-04-2026",
        "withdrawal_last_date": "13-04-2026",
        "polling": "29-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Tamil Nadu",
    "state_hi": "तमिलनाडु",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 234,
        "notification": "30-03-2026",
        "nomination_last_date": "06-04-2026",
        "scrutiny_last_date": "07-04-2026",
        "withdrawal_last_date": "09-04-2026",
        "polling": "23-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Kerala",
    "state_hi": "केरल",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 140,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Assam",
    "state_hi": "असम",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 126,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Puducherry",
    "state_hi": "पुदुचेरी",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 30,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  }
]
const FiveElectionSchedule = ({ state, state_en }) => {
  const masterconfig = useContext(MasterConfigContext);
  const widgetKey = masterconfig?.["assembly_widgets_2026"]?.["scheduleFrame"];
  if (!widgetKey || !state) {
    return null;
  }
  const scheduleHtml = () => {
    return widgetKey[state];
  };
  const scheduleUrl = scheduleHtml()

  return (
    <div className="w-full my-4 ">

 
<div className="space-y-8">
  {scheduleData
    ?.filter((s) => s.state_en === state_en)
    .map((state, index) => (
      <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {state.phases.map((phase, i) => (
          <div
            key={i}
            className="relative rounded-xl border border-gray-200 shadow-sm overflow-hidden bg-white"
          >
            {/* Left Red Border */}
            <div className="absolute left-0 top-0 h-full w-1 bg-red-500"></div>

            {/* Card Header */}
            <div className="flex justify-between items-start p-4 pl-5 bg-[#F9FAFB]">
              <div>
                <h2 className="text-xl font-bold text-black">
                  {phase.phase}
                </h2>
                <p className="text-sm text-gray-600">
                  {phase.phase_en || `Phase ${i + 1}`}
                </p>
              </div>

              <div className="bg-white flex items-center rounded-md px-3 py-2 shadow-md">
                <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/seat_icon.svg"} className="w-5 h-5" />
                <div className="ml-2 text-center">
                  <p className="text-xs text-gray-500">सीटें</p>
                  <p className="text-red-500 font-bold text-lg">
                    {phase.seats}
                  </p>
                </div>
              </div>
            </div>

            {/* Schedule Rows */}
            <div>
              <div className="flex items-center gap-3 px-4 py-2 pl-5">
                <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/notification_icon.svg"} className="w-4 h-4" />
                <div>
                  <p className="text-sm text-gray-600">नोटिफिकेशन</p>
                  <p className="font-semibold">{phase.notification}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 px-4 py-2 pl-5">
                <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/nomination_icon.svg"} className="w-4 h-4" />
                <div>
                  <p className="text-sm text-gray-600">
                    नामांकन की अंतिम तारीख
                  </p>
                  <p className="font-semibold">
                    {phase.nomination_last_date}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 px-4 py-2 pl-5">
                <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/scrutiny_icon.svg"} className="w-4 h-4" />
                <div>
                  <p className="text-sm text-gray-600">
                    जांच की अंतिम तारीख
                  </p>
                  <p className="font-semibold">
                    {phase.scrutiny_last_date}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 px-4 py-2 pl-5">
                <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/withdrawl_icon.svg"} className="w-4 h-4" />
                <div>
                  <p className="text-sm text-gray-600">
                    वापस लेने की अंतिम तारीख
                  </p>
                  <p className="font-semibold">
                    {phase.withdrawal_last_date}
                  </p>
                </div>
              </div>

              {/* Highlighted last two rows */}
              <div className="flex items-center gap-3 mx-4 px-4 py-3 pl-5 mb-2 bg-[#F9FAFB]  rounded-md">
              <div className="w-8 h-8 rounded-lg bg-white flex justify-center items-center"><SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/polling_icon.svg"} className="w-5 h-5 " /> </div>
                <div>
                  <p className="text-sm text-gray-700">मतदान की तारीख</p>
                  <p className="font-semibold">{phase.polling}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 mx-4 px-4 py-3 mb-3 pl-5 bg-[#F9FAFB] rounded-md">
              <div className="w-8 h-8 rounded-lg bg-white flex justify-center items-center"> <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/counting_icon.svg"} className="w-5 h-5 " /> </div>
                <div>
                  <p className="text-sm text-gray-700">मतगणना की तारीख</p>
                  <p className="font-semibold">{phase.counting}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ))}
</div>
      <iframe
        src={scheduleUrl}
        style={{ width: '100%', height: '100vh', overflow: 'hidden' }}
        className="scrollbar-none my-4"
        title="Election Schedule"
      >
      </iframe>
    </div>
  );
};

export default FiveElectionSchedule;
